<script>
import Vue from 'vue'

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = event => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
})

export default {
  props: {
    optionsFont: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      value: '',
      label: '',
      isShow: false,
    }
  },

  created() {
    this.loadSelectLabel()
  },

  methods: {
    loadSelectLabel() {
      if (this.selected) {
        this.label = this.optionsFont.filter(
          item => item.value === this.selected
        )[0].label
      } else {
        this.label = this.optionsFont[0].label
      }
    },
    onClickOption(option) {
      this.value = option.value
      this.label = option.label
      this.isShow = false
      this.$emit('input', option.value)
    },

    onClickDropdown() {
      this.isShow = !this.isShow
    },

    onClickOutside: function() {
      this.isShow = false
    },
  },
}
</script>

<template>
  <div class="dropdown">
    <span class="label">フォント</span>
    <div class="dropdown-content" v-click-outside="onClickOutside">
      <div class="dropdown-content-input" @click="onClickDropdown">
        <p class="value">{{ label }}</p>
      </div>
      <div v-show="isShow" class="dropdown-content-options">
        <p
          v-for="option in optionsFont"
          :key="option.value"
          class="option-item"
          :class="option.classFont"
          @click="onClickOption(option)"
        >
          {{ option.label }}
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'select-custom.scss';
</style>
